import axios from "axios"

const BASE = "/api/wfl/groups_management/companies"

export interface Address {
  country: string
  city: string
  street: string
  streetNum: string
  postalCode: string
  state: string | null
}

export interface FinancialInfoResponse {
  vatNum: string
  address: Address
  paymentThreshold: number | null
  currency: string
  minimumGlobalPaymentThreshold: number
  canModifyCurrency: boolean
}

export interface ContactPerson {
  name: string
  surname: string
  mail: string
  phone: string
}

export interface FinancialInfoRequest {
  vatNum: string
  address: Address
  paymentThreshold: number | null
  currency: string
}

export function getFinancialInfo(companyId: string) {
  return axios.get<FinancialInfoResponse>(`${BASE}/${companyId}/financialInfo`).then((r) => r.data)
}

export function putFinancialInfo(companyId: string, financialInfo: FinancialInfoRequest) {
  return axios.put<void>(`${BASE}/${companyId}/financialInfo`, financialInfo).then((r) => r.data)
}

export function getContact(companyId: string) {
  return axios.get<ContactPerson>(`${BASE}/${companyId}/contact`).then((r) => r.data)
}

export function putContact(companyId: string, contact: ContactPerson) {
  return axios.put<void>(`${BASE}/${companyId}/contact`, contact).then((r) => r.data)
}
